import { Component, EventEmitter, Input, Output } from "@angular/core";
import { DebounceTrigger } from "../../models/debounce-trigger.model";

@Component({
    selector: 'spv2-grid-filter-base',
    template: '',
    styleUrls: [],
    standalone: false
})
export class GridFilterBase<T> {

    private _value: T;
    
    @Input()
    public set value(v : T) {
        this._value = v;
    }

    public get value(): T {
        return this._value;
    }

    @Output() valueChange = new EventEmitter<T>();
    @Output() searchTriggered = new EventEmitter();  

    debounceTime: number = 0;
    searchTrigger: DebounceTrigger<void>;

    ngOnInit() {
        this.searchTrigger = new DebounceTrigger(() => this.triggerSearch(), this.debounceTime);
    }

    triggerSearch() {
        this.valueChange.emit(this.value);
        this.searchTriggered.emit();
    }

    startDebounce() {
        this.searchTrigger.execute()
    }
}